<template lang="pug">
section.head
  .head__logo
  .head__title(v-html="$t('promo.head.title')")
  button.button(v-if="isUserInProject" @click="downloadGame" v-html="$t('promo.button.download')")
  .head__desc.head__text(v-html="$t('promo.head.desc')")
  .head__authed(v-if="isUserInProject")
    .head__text(v-html="$t('promo.head.your_balance')")
    .head__balance__wrap
      .head__balance(v-html="balance")
      .head__replenish
        .head__replenish__button(:class="{ 'head__replenish__button--disabled': !isCurrentReplenishNotZero }" @click="showReplenishModal")
        .head__replenish__count(v-html="calculatedReplenish")
    button.button(@click="scrollToBlock" v-html="$t('promo.button.authed')")
  .head__noauth(v-else)
    button.button.button--large(@click="downloadGame" v-html="$t('promo.button.download')")
    button.button.button--large(@click="openReg" v-html="$t('promo.button.not_authed')")

  Popup(v-if="isShowReplenishModal" @close="closeReplenishModal")
    template(#head)
      div(v-html="$t('promo.head.popup.title')")
    template(#body)
      .popup__desc(v-html="$t('promo.head.popup.desc')")
      .popup__content
        .equation__left(v-html="replenishPrice")
        .equation__middle(v-html="'='")
        .equation__right(v-html="replenishAmount")
      .popup__error(v-if="replenishError" v-html="$t('promo.head.popup.error')")
    template(#buttons)
      button.button(
        :class="{ 'button--disabled': !replenishButtonAvailable }"
        :disabled="!replenishButtonAvailable"
        @click="successReplenish"
        v-html="$t('promo.button.buy')"
      )
</template>

<script>
import Popup from "./Popup";
export default {
  name: "PromoHead",
  components: {
    Popup,
  },
  props: {
    isUserInProject: {
      type: Boolean,
      default: false,
    },
    activityKey: {
      type: String,
      default: null,
    },
    openReg: {
      type: Function,
      default: () => {},
    },
    balance: {
      type: Number,
      default: null,
    },
    currentReplenishCount: {
      type: Number,
      default: null,
    },
    maxReplenishCount: {
      type: Number,
      default: null,
    },
    replenishPrice: {
      type: Number,
      default: null,
    },
    replenishAmount: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isShowReplenishModal: false,
      replenishError: false,
      replenishButtonAvailable: true,
    };
  },
  computed: {
    isCurrentReplenishNotZero() {
      return this.currentReplenishCount > 0;
    },
    calculatedReplenish() {
      return this.currentReplenishCount + "/" + this.maxReplenishCount;
    },
  },
  methods: {
    scrollToBlock() {
      const yOffset = 100;
      const element = document.querySelector(".scroll_challenges");
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    },
    showReplenishModal() {
      if (this.isCurrentReplenishNotZero) {
        this.isShowReplenishModal = true
      }
    },
    downloadGame() {
      this.$authService.downloadGameCenter();
    },
    closeReplenishModal() {
      this.isShowReplenishModal = false
    },
    successReplenish() {
      this.replenishError = false;
      this.replenishButtonAvailable = false;

      this.$api.questsWithRatingService
        .buyPoints(this.activityKey)
        .run()
        .then(response => {
          this.replenishButtonAvailable = true;
          if (this.$api.isApiResponseError(response)) {
            this.replenishError = true;
          } else {
            this.$emit("updatePromoAfterReplenish")
            this.closeReplenishModal()
          }
        });
    },
  },
};
</script>
